import { useEffect } from 'react';
import styles from './EstadoModal.module.css';

interface Props {
  open: boolean;
  nombre: string;
  itemsCount: number;
  submitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirmación de archivado de una partida.
 * Lenguaje suave — soft delete, no hard delete. Reversible.
 */
export function ConfirmArchiveModal({
  open,
  nombre,
  itemsCount,
  submitting,
  onCancel,
  onConfirm,
}: Props) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onCancel();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  if (!open) return null;
  return (
    <div className={styles.backdrop} onClick={onCancel}>
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        style={{ borderTop: '4px solid #dc2626' }}
      >
        <div className={styles.header}>
          <div
            className={styles.icon}
            style={{ background: 'rgba(239,68,68,0.15)', color: '#dc2626' }}
          >
            🗄
          </div>
          <div>
            <h2 className={styles.title}>Archivar partida</h2>
            <div className={styles.subtitle}>{nombre}</div>
          </div>
        </div>
        <div style={{ padding: '4px 22px 14px', fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.55 }}>
          Vas a archivar esta partida
          {itemsCount > 0 && (
            <> junto con sus <strong>{itemsCount} ítem{itemsCount === 1 ? '' : 's'}</strong></>
          )}
          . Podrás restaurarla cuando quieras desde la sección{' '}
          <strong>"Archivados"</strong>.
        </div>
        <div className={styles.actions} style={{ padding: '0 22px 18px' }}>
          <button
            type="button"
            className={styles.btnSecondary}
            onClick={onCancel}
            disabled={submitting}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={styles.btnPrimary}
            onClick={onConfirm}
            disabled={submitting}
            style={{ background: '#dc2626' }}
          >
            {submitting ? 'Archivando…' : 'Sí, archivar'}
          </button>
        </div>
      </div>
    </div>
  );
}
